import { render } from "./document-list-modal.vue?vue&type=template&id=232b61dc&scoped=true"
import script from "./document-list-modal.vue?vue&type=script&lang=js"
export * from "./document-list-modal.vue?vue&type=script&lang=js"

import "./document-list-modal.vue?vue&type=style&index=0&id=232b61dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232b61dc"]])

export default __exports__